<template>
  <div class="cus-search-item" :style="[boxStyle]">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "cus-search-item",
    props: {
      align: {
        type: String,
        default: 'flex-start'
      }
    },
    computed: {
      boxStyle(){
        let style = {}
        style.justifyContent = this.align
        return style;
      }
    }
  }
</script>

<style scoped lang="less">
  .cus-search-item{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/cuview-ui/components/cus-search-item/cus-search-item.vue